export function globalStores() {
  // Window could be missing during SSR, this protects against SSR errors
  if (typeof window !== 'undefined') {
    if (!window.stores) {
      window.stores = Object.create(null);
    }
    return window.stores;
  }
  return undefined;
}
